/**
 * Shared configuration for browser and Node.js
 *
 * Browser: same-origin by default — Vite bundles a build-time
 *   `VITE_API_BASE` (e.g. `''` for same-origin in prod) into the bundle,
 *   and we fall back to `http://localhost:3001` for local dev (where the
 *   API runs on a different port than the Vite dev server).
 *
 * Node: always `http://localhost:3001` (REPL / smoke tests / the server
 *   talking to itself).
 */

import { LogLevel } from './nodes/INode';

const isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';

// Vite injects `__VITE_API_BASE__` at build time via `define` in vite.config.ts.
// In Node (no Vite), the symbol is undefined.
declare const __VITE_API_BASE__: string | undefined;
const envBase: string | undefined =
  typeof __VITE_API_BASE__ !== 'undefined' ? __VITE_API_BASE__ : undefined;

function deriveApiUrl(): string {
  if (envBase !== undefined) return envBase; // '' means same-origin
  if (isBrowser) return window.location.origin;
  return 'http://localhost:3001';
}

function deriveWsUrl(): string {
  const api = deriveApiUrl();
  if (api === '') {
    // Same-origin WS in browser
    if (isBrowser) {
      return (window.location.protocol === 'https:' ? 'wss://' : 'ws://') + window.location.host;
    }
    return 'ws://localhost:3001';
  }
  return api.replace(/^http/, 'ws');
}

export const config = {
  apiUrl: deriveApiUrl(),
  wsUrl: deriveWsUrl(),
  logLevel: LogLevel.Trace
};
